/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const OrderExportRowDTOOrderStatusEnum = {
    PendingAvailability: 'PENDING_AVAILABILITY',
    Pending: 'PENDING',
    Unshipped: 'UNSHIPPED',
    PartiallyShipped: 'PARTIALLY_SHIPPED',
    Shipped: 'SHIPPED',
    InvoiceUnconfirmed: 'INVOICE_UNCONFIRMED',
    Cancelled: 'CANCELLED',
    Unfulfillable: 'UNFULFILLABLE'
};
/**
 * @export
 */
export const OrderExportRowDTOPackageStatusEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * @export
 */
export const OrderExportRowDTOProfitStateEnum = {
    Normal: 'NORMAL',
    Voided: 'VOIDED',
    Loss: 'LOSS',
    Refunded: 'REFUNDED'
};
/**
 * Check if a given object implements the OrderExportRowDTO interface.
 */
export function instanceOfOrderExportRowDTO(value) {
    return true;
}
export function OrderExportRowDTOFromJSON(json) {
    return OrderExportRowDTOFromJSONTyped(json, false);
}
export function OrderExportRowDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'amazonOrderId': json['amazonOrderId'] == null ? undefined : json['amazonOrderId'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'buyerOrderId': json['buyerOrderId'] == null ? undefined : json['buyerOrderId'],
        'flagName': json['flagName'] == null ? undefined : json['flagName'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'purchaseDate': json['purchaseDate'] == null ? undefined : (new Date(json['purchaseDate'])),
        'shipByDate': json['shipByDate'] == null ? undefined : (new Date(json['shipByDate'])),
        'deliverByDate': json['deliverByDate'] == null ? undefined : (new Date(json['deliverByDate'])),
        'asin': json['asin'] == null ? undefined : json['asin'],
        'sellerSku': json['sellerSku'] == null ? undefined : json['sellerSku'],
        'title': json['title'] == null ? undefined : json['title'],
        'quantityOrdered': json['quantityOrdered'] == null ? undefined : json['quantityOrdered'],
        'orderTotalAmount': json['orderTotalAmount'] == null ? undefined : json['orderTotalAmount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'salePriceUsd': json['salePriceUsd'] == null ? undefined : json['salePriceUsd'],
        'salesTaxUsd': json['salesTaxUsd'] == null ? undefined : json['salesTaxUsd'],
        'referralFeeUsd': json['referralFeeUsd'] == null ? undefined : json['referralFeeUsd'],
        'productCostUsd': json['productCostUsd'] == null ? undefined : json['productCostUsd'],
        'extraCostUsd': json['extraCostUsd'] == null ? undefined : json['extraCostUsd'],
        'couponUsd': json['couponUsd'] == null ? undefined : json['couponUsd'],
        'warehouseCostUsd': json['warehouseCostUsd'] == null ? undefined : json['warehouseCostUsd'],
        'refundUsd': json['refundUsd'] == null ? undefined : json['refundUsd'],
        'netProceedsUsd': json['netProceedsUsd'] == null ? undefined : json['netProceedsUsd'],
        'totalCostUsd': json['totalCostUsd'] == null ? undefined : json['totalCostUsd'],
        'profitUsd': json['profitUsd'] == null ? undefined : json['profitUsd'],
        'profitPercent': json['profitPercent'] == null ? undefined : json['profitPercent'],
        'profitState': json['profitState'] == null ? undefined : json['profitState'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'carrierName': json['carrierName'] == null ? undefined : json['carrierName'],
    };
}
export function OrderExportRowDTOToJSON(json) {
    return OrderExportRowDTOToJSONTyped(json, false);
}
export function OrderExportRowDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'amazonOrderId': value['amazonOrderId'],
        'marketplace': value['marketplace'],
        'buyerOrderId': value['buyerOrderId'],
        'flagName': value['flagName'],
        'orderStatus': value['orderStatus'],
        'packageStatus': value['packageStatus'],
        'purchaseDate': value['purchaseDate'] == null ? undefined : ((value['purchaseDate']).toISOString()),
        'shipByDate': value['shipByDate'] == null ? undefined : ((value['shipByDate']).toISOString()),
        'deliverByDate': value['deliverByDate'] == null ? undefined : ((value['deliverByDate']).toISOString()),
        'asin': value['asin'],
        'sellerSku': value['sellerSku'],
        'title': value['title'],
        'quantityOrdered': value['quantityOrdered'],
        'orderTotalAmount': value['orderTotalAmount'],
        'currencyCode': value['currencyCode'],
        'salePriceUsd': value['salePriceUsd'],
        'salesTaxUsd': value['salesTaxUsd'],
        'referralFeeUsd': value['referralFeeUsd'],
        'productCostUsd': value['productCostUsd'],
        'extraCostUsd': value['extraCostUsd'],
        'couponUsd': value['couponUsd'],
        'warehouseCostUsd': value['warehouseCostUsd'],
        'refundUsd': value['refundUsd'],
        'netProceedsUsd': value['netProceedsUsd'],
        'totalCostUsd': value['totalCostUsd'],
        'profitUsd': value['profitUsd'],
        'profitPercent': value['profitPercent'],
        'profitState': value['profitState'],
        'trackingNumber': value['trackingNumber'],
        'carrierName': value['carrierName'],
    };
}
